/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiErrorDTO, ApiErrorMessageDTO } from '@api/models';

export class ApiErrorDecoder {
  protected error: ApiErrorMessageDTO;

  protected defaultMessage: string;

  constructor(
    error: ApiErrorDTO,
    options?: {
      defaultMessage?: string;
    }
  ) {
    this.error = this.decodeError(error);
    this.defaultMessage = (options && options.defaultMessage) || '';
  }

  /**
   * restituisce il messaggio di errore
   */
  getMessage(): string {
    const message = this.error.message;

    if (
      typeof message === 'string' &&
      message.toUpperCase() !== 'GENERIC_ERROR'
    ) {
      return message;
    } else if (typeof this.defaultMessage === 'string') {
      return this.defaultMessage;
    } else {
      return 'Error';
    }
  }

  /**
   * restituisce il codice dell'errore
   */
  getCode(): string {
    return this.error.code || '';
  }

  /**
   * restituisce l'id parziale di errore
   */
  getPartialUuid(): string {
    const uuid = this.getUuid();

    if (typeof uuid === 'string' && uuid.indexOf('-') > -1) {
      return uuid.substring(0, uuid.indexOf('-'));
    } else {
      return uuid;
    }
  }

  /**
   * restituisce l'id dell'errore
   */
  getUuid(): string {
    return this.error.uuid || '0';
  }

  /**
   * decodifica l'errore
   */
  protected decodeError(error: any): ApiErrorMessageDTO {
    if (typeof error === 'string') {
      try {
        error = JSON.parse(error);
      } catch (_) {
        error = {};
      }
    }

    let code: string;
    let message: string;
    let severity: string;
    let title: string;
    let uuid: string;

    // errore qinetic standard
    if (error && error.messages instanceof Array && error.messages[0]) {
      code = error.messages[0].code;
      message = error.messages[0].message;
      severity = error.messages[0].severity;
      title = error.messages[0].title;
      uuid = error.messages[0].uuid;
    } // errore mobile security
    else if (error && typeof error.localizedMessage === 'string') {
      code = 'error';
      title = error.localizedMessage;
      message = error.localizedMessage;
    }
    // errore IBM
    else if (error && typeof error.error === 'string') {
      code = error.cdErrorCode;
      title = error.error;
      message = error.error_description;
    } else {
      error = {};
    }

    return {
      category: null,
      code: code || null,
      message: message || null,
      renderingMode: null,
      severity: severity || null,
      title: title || null,
      uuid: uuid || null
    };
  }
}
